<template>
  <Modal @close="close">
    <template v-slot:header>Pagamento</template>
    <template v-slot:body>
      <div class="pix-wrapper" v-if="!isLoading">
        <div>
          <span class="pix-label">Comprar:</span>
          <span class="pix-value">{{
            maskMoney((currentOrder || {}).total)
          }}</span>
        </div>

        <div class="pix-logo">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M11.7317 13.44C11.9423 13.2295 12.3094 13.2288 12.5199 13.44L15.5198 16.4397C16.0746 16.9944 16.8126 17.2999 17.5973 17.2999H17.9587L14.1484 21.1101C12.9619 22.2966 11.0381 22.2966 9.85151 21.1101L6.05229 17.3108H6.64342C7.42813 17.3108 8.1661 17.0053 8.721 16.4507L11.7317 13.44ZM5.20156 7.53994C5.25 7.55819 5.30137 7.57118 5.35621 7.57118H6.64344C7.1847 7.57118 7.7144 7.79064 8.09688 8.17331L11.1079 11.1843C11.3886 11.4648 11.7572 11.6053 12.126 11.6053C12.4946 11.6053 12.8634 11.4648 13.144 11.1841L16.1438 8.18422C16.5262 7.80155 17.056 7.58209 17.5973 7.58209H18.6441C18.702 7.58209 18.7569 7.56939 18.8076 7.54907L21.1101 9.85158C22.2966 11.0381 22.2966 12.9619 21.1101 14.1485L18.8077 16.4509C18.7569 16.4305 18.7021 16.4179 18.6441 16.4179H17.5973C17.056 16.4179 16.5262 16.1985 16.1438 15.8157L13.144 12.8162C12.6004 12.272 11.6518 12.2722 11.1076 12.816L8.09688 15.8267C7.7144 16.2094 7.1847 16.4288 6.64344 16.4288H5.35621C5.30137 16.4288 5.24991 16.4418 5.20147 16.4601L2.88993 14.1485C1.70336 12.9619 1.70336 11.0381 2.88993 9.85158L5.20156 7.53994ZM9.85153 2.88993C11.0381 1.70336 12.9619 1.70336 14.1485 2.88993L17.9586 6.70008H17.5973C16.8126 6.70008 16.0746 7.00562 15.5197 7.56024L12.52 10.5603C12.3026 10.7783 11.9485 10.7774 11.7317 10.5606L8.72093 7.54933C8.16611 6.99471 7.42815 6.68908 6.64344 6.68908H6.05241L9.85153 2.88993Z"
              fill="currentColor"
            />
          </svg>
          <span>Pix</span>
        </div>

        <div
          class="pix-qrcode"
          v-if="(currentOrder || {}).qrCode && currentOrder.remainingTime !== 0"
        >
          <QrcodeVue :value="currentOrder.qrCode" size="120"></QrcodeVue>
        </div>

        <b-button
          type="is-primary"
          class="is-rounded is-medium pix-copy"
          @click.prevent="copyPix"
          v-if="currentOrder.remainingTime !== 0"
          >copiar código</b-button
        >
        <span class="pix-time-left" v-if="currentOrder.remainingTime !== 0"
          >{{ timeRemaining }}
        </span>

        <p class="warning-text" v-if="(currentOrder || {}).remainingTime === 0">
          <svg
            width="71"
            height="72"
            viewBox="0 0 71 72"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M35.5 70.1666C54.3697 70.1666 69.6666 54.8697 69.6666 35.9999C69.6666 17.1302 54.3697 1.83325 35.5 1.83325C16.6303 1.83325 1.33331 17.1302 1.33331 35.9999C1.33331 54.8697 16.6303 70.1666 35.5 70.1666Z"
              stroke="#FF453A"
              stroke-width="2"
              stroke-linecap="square"
              stroke-linejoin="round"
            />

            <path
              d="M47.3501 25.5628L48.0572 24.8557L46.6429 23.4415L45.9358 24.1486L47.3501 25.5628ZM23.6487 46.4358L22.9416 47.1429L24.3558 48.5571L25.0629 47.85L23.6487 46.4358ZM25.0629 24.1486L24.3558 23.4415L22.9416 24.8557L23.6487 25.5628L25.0629 24.1486ZM45.9358 47.85L46.6429 48.5571L48.0572 47.1429L47.3501 46.4358L45.9358 47.85ZM45.9358 24.1486L23.6487 46.4358L25.0629 47.85L47.3501 25.5628L45.9358 24.1486ZM23.6487 25.5628L45.9358 47.85L47.3501 46.4358L25.0629 24.1486L23.6487 25.5628Z"
              fill="#FF453A"
            />
          </svg>

          <br />

          <strong>PIX expirado!</strong><br />
          Gere um novo código e conclua <br />
          o pagamento no tempo indicado.
        </p>

        <button
          v-if="
            (currentOrder || {}).status === 'PENDING' &&
            (currentOrder || {}).remainingTime !== 0
          "
          @click.prevent="cancel"
          class="button is-light is-medium is-rounded cancel-order"
        >
          Cancelar Pix
        </button>
      </div>
      <div v-if="isLoading" class="loading-container">
        <b-loading :is-full-page="false" :active.sync="isLoading" />
      </div>
    </template>
  </Modal>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import Modal from "../layout/Modal";
import { moneyFilter } from "../filters/money";
import orders from "../services/orders";

export default {
  name: "PixModal",
  props: {
    order: {
      type: Object,
    },
  },
  components: {
    Modal,
    QrcodeVue,
  },
  data() {
    return {
      isLoading: false,
      currentOrder: {},
      expirationDate: null,
      timeRemaining: "00:00:00",
      timeRemainingInterval: null,
    };
  },
  watch: {
    order: {
      immediate: true,
      handler(newOrderValue) {
        this.currentOrder = newOrderValue;
      },
    },
  },
  mounted() {
    this.update();
  },
  beforeUnmount() {
    clearInterval(this.timeRemainingInterval);
  },
  methods: {
    update() {
      const now = new Date();
      const totalTime = this.currentOrder.remainingTime * 1000;
      this.expirationDate = new Date(now.getTime() + totalTime);

      this.updateRemainingTime();
    },
    maskMoney(param) {
      return moneyFilter(param);
    },
    formatTime(number) {
      if (number < 10) {
        return "0" + number;
      }

      return number;
    },
    updateRemainingTime() {
      clearInterval(this.timeRemainingInterval);

      this.timeRemainingInterval = setInterval(() => {
        const remaining = this.expirationDate - new Date();
        const hours = Math.floor((remaining / (1000 * 60 * 60)) % 24);
        const seconds = Math.floor((remaining / 1000) % 60);
        const minutes = Math.floor((remaining / 1000 / 60) % 60);

        this.timeRemaining = [hours, minutes, seconds]
          .map((time) => this.formatTime(time))
          .join(":");

        if (seconds <= 0 && hours <= 0 && minutes <= 0) {
          this.remainingTime = "00:00:00";
          this.currentOrder.remainingTime = 0;
          clearInterval(this.timeRemainingInterval);
          return;
        }
      }, 1000);
    },
    close() {
      clearInterval(this.timeRemainingInterval);
      this.$emit("close");
    },
    cancel() {
      this.isLoading = true;

      orders
        .cancel(this.currentOrder.id)
        .then(() => {
          this.$root.$emit(`set-pending-order`, null);

          this.$buefy.toast.open({
            message: "PIX Cancelado!",
            type: "is-success",
          });

          this.$root.$emit("update-list");
          this.close();
        })
        .catch((error) => {
          const message =
            (((error || {}).response || {}).data || {}).message ||
            "Ocorreu um erro inesperado, Por favor tente novamente em instantes";

          this.$buefy.toast.open({
            message,
            type: "is-danger",
          });
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    copyPix() {
      this.$copyText(this.currentOrder.qrCode)
        .then(() => {
          this.$buefy.toast.open({
            message: "Pix copiado!",
            type: "is-success",
          });
        })
        .catch(() => {
          this.$buefy.toast.open({
            message: "Error ao copiar",
            type: "is-danger",
          });
        });
    },
    refresh() {
      this.isLoading = true;
      orders
        .get(this.order.id)
        .then((order) => {
          this.currentOrder = order;
          this.update();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
.pix-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.pix-label {
  font-weight: 700;
  display: inline-flex;
  margin-right: 5px;
}

.pix-value {
  font-weight: 700;
  display: inline-flex;
  margin-right: 5px;
  color: #09b6f3;
  font-size: 19px;
}

.pix-copy {
  font-weight: 700;
  text-transform: uppercase;
  font-size: 15px !important;
  padding: 25px 25px !important;
}

.pix-logo {
  display: flex;
  align-items: center;

  > svg {
    width: 40px;
    height: 40px;
  }

  > span {
    font-size: 20px;
    display: inline-flex;
    margin-left: 10px;
  }
}

.pix-time-left {
  font-weight: 700;
  font-size: 21px;
  margin-bottom: 20px;
}

.pix-qrcode {
  width: 140px;
  height: 140px;
  background-color: white;
  padding: 10px;
  border-radius: 8px;
  margin: 30px 0;
}

.pix-wrapper {
  .cancel-order {
    font-size: 0.75rem;
    border-radius: 50px;
    padding: 0.5rem 1.5rem;
    height: 2.8rem;
    text-transform: uppercase;
    font-weight: 700;
    margin-bottom: 20px;
  }

  .warning-text {
    margin: 30px 0 10px;
    text-align: center;
    > strong {
      color: #fff;
    }

    > svg {
      display: inline-block;
      margin-bottom: 10px;
    }
  }
}
</style>
<style lang="scss">
.loading-container {
  min-height: 100px;

  .loading-background {
    background: transparent !important;
  }
}
</style>
